module.exports = __webpack_public_path__ + "static/media/1.b86e3fbd.png";